import React from 'react';

export const DecorationUnderlineShort = () => {
    return (
        <svg width="156" height="24" viewBox="0 0 156 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M146 14C146 14 105.786 11.0716 79.2197 10.3297C52.6532 9.58785 10 10.3297 10 10.3297"
                  stroke="url(#paint0_linear_227_2)" stroke-width="19.781" stroke-linecap="round"/>
            <defs>
                <linearGradient id="paint0_linear_227_2" x1="146" y1="12" x2="10" y2="12"
                                gradientUnits="userSpaceOnUse">
                    <stop stop-color="#934CFF" stop-opacity="0.1"/>
                    <stop offset="0.649295" stop-color="#934CFF" stop-opacity="0.4"/>
                    <stop offset="1" stop-color="#934CFF" stop-opacity="0.2"/>
                </linearGradient>
            </defs>
        </svg>
    )
}